<template>
  <div>
    <h1 class="text-2xl font-bold mb-4">En attente</h1>
    <Alert>
      Lorsqu’un paiement est effectué par prélèvement SEPA, une période de validation est nécessaire avant que le
      paiement ne soit définitivement confirmé. Cette validation peut prendre jusqu’à 5 jours ouvrés, mais ce délai peut
      varier.
    </Alert>
    <LeadsList status="waiting_for_confirmation" :noDataMsg="$t('NoLeadProcessing')" />
  </div>
</template>

<script>
import { Alert } from "@estaly/ui";
import LeadsList from "@/components/leads/LeadsList.vue";

export default {
  components: {
    Alert,
    LeadsList,
  },
};
</script>
